module.exports = __webpack_public_path__ + "Roboto-Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Medium.ttf
// module id = 94
// module chunks = 0